"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplicaAdGroupTargetingKeywordSnapshotStatisticsQuerySchema = exports.ReplicaAdGroupTargetingKeywordSnapshotStatisticsResponseSchema = exports.ListReplicaAdGroupTargetingKeywordSnapshotQuerySchema = exports.ListReplicaAdGroupTargetingKeywordQuerySchema = exports.ListReplicaAdGroupTargetingKeywordSnapshotResponseSchema = exports.ListReplicaAdGroupTargetingKeywordResponseSchema = exports.UpdateReplicaAdGroupTargetingKeywordsBodySchema = exports.UpdateReplicaAdGroupTargetingKeywordBodySchema = exports.ReplicaAdGroupTargetingKeywordSnapshotSchema = exports.ReplicaAdGroupTargetingKeywordSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("./common");
const ReplicaAdGroupTargetingKeywordSchemaFields = {
    ...common_1.ReplicaMetadataFields,
    adGroupRef: ruby_1.AppleProxyRefSchema,
    keywordRef: ruby_1.AppleProxyRefSchema,
    body: apple_proxy_web_1.AppleProxyKeywordSchema,
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
    keywordId: typebox_1.Type.Optional(core_1.IdSchema),
    duration: core_1.DurationSchema,
};
exports.ReplicaAdGroupTargetingKeywordSchema = (0, core_1.StrictObject)({
    ...ReplicaAdGroupTargetingKeywordSchemaFields,
});
exports.ReplicaAdGroupTargetingKeywordSnapshotSchema = (0, core_1.StrictObject)({
    ...ReplicaAdGroupTargetingKeywordSchemaFields,
    period: typebox_1.Type.Integer(),
});
/**
 * Body
 */
exports.UpdateReplicaAdGroupTargetingKeywordBodySchema = (0, core_1.StrictObject)({
    body: apple_proxy_web_1.AppleProxyKeywordSchema,
});
exports.UpdateReplicaAdGroupTargetingKeywordsBodySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaMetadataFields,
    keywords: typebox_1.Type.Array(exports.UpdateReplicaAdGroupTargetingKeywordBodySchema),
});
/**
 * Response
 */
exports.ListReplicaAdGroupTargetingKeywordResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaAdGroupTargetingKeywordSchema);
exports.ListReplicaAdGroupTargetingKeywordSnapshotResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaAdGroupTargetingKeywordSnapshotSchema);
/**
 * Parameters
 */
exports.ListReplicaAdGroupTargetingKeywordQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataQueryFields,
    adGroupRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    keywordRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    keywordId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
});
exports.ListReplicaAdGroupTargetingKeywordSnapshotQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaMetadataSnapshotQueryFields,
    adGroupRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    keywordRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    keywordId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
});
// Statistics
exports.ReplicaAdGroupTargetingKeywordSnapshotStatisticsResponseSchema = (0, core_1.StrictObject)({
    groups: typebox_1.Type.Array((0, core_1.StrictObject)({
        key: typebox_1.Type.Optional(core_1.IdSchema),
        values: (0, core_1.StrictObject)({
            avgBidAmount: core_1.MoneySchema,
            minBidAmount: core_1.MoneySchema,
            maxBidAmount: core_1.MoneySchema,
        }),
        count: core_1.CountSchema,
    })),
});
exports.ReplicaAdGroupTargetingKeywordSnapshotStatisticsQuerySchema = (0, core_1.StrictObject)({
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    campaignRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    country: typebox_1.Type.Optional(core_1.CountrySchema),
    to: typebox_1.Type.Optional(core_1.TimestampSchema),
    from: typebox_1.Type.Optional(core_1.TimestampSchema),
    adGroupRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    keywordRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
    keywordId: typebox_1.Type.Optional(core_1.IdSchema),
});
